module.exports = {
  copy: require('./copy')
}



//////////////////
// WEBPACK FOOTER
// ./~/github-download/~/fs-extra/lib/copy/index.js
// module id = 843
// module chunks = 0